import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { removeScrollbar } from '@/styles/helpers';

export const Box = styled.div`
  padding-top: 40px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  padding-bottom: 15px;
`;

export const Title = styled(Typography.Header)`
  padding-left: 15px;
`;

export const Text = styled(Typography.Body)`
  margin-top: 20px;
`;

export const List = styled.div`
  ${removeScrollbar()}
  display: flex;
  gap: 20px;
  overflow-x: scroll;
  margin-top: 20px;
`;

export const Item = styled.div<{ $bg: string }>`
  flex: 1 0 230px;
  padding: 25px 15px;
  gap: 20px;
  border-radius: 7px;
  background: ${({ $bg }) => $bg};

  &:first-child {
    margin-left: 15px;
  }

  &:last-child {
    margin-right: 15px;
  }
`;

export const Name = styled(Typography.Title)`
  text-align: center;
  margin-bottom: 15px;
  text-transform: uppercase;
`;

export const Price = styled(Typography.Header)`
  text-align: center;
  margin-bottom: 20px;
`;

export const Adv = styled(Typography.Body)`
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const BuyButton = styled(Button)`
  margin-top: 20px;
`;
